// src/components/doctor-profile/PracticeLocation.jsx
import React, { useRef, useEffect } from "react";
import { MapPin, Navigation } from "lucide-react";
import { styles as baseStyles } from "../../style/DoctorProfile.styles";

/**
 * PracticeLocation (dumb container)
 * - No script/ready flags. Never covers the map once coords exist.
 * - If no coords: shows a small info fallback.
 */
const PracticeLocation = ({
  doctorName = "Doctor",
  location = {},
  mapRef,
  directionsUrl,
  mapHeight = 360,
  styles = baseStyles,
}) => {
  const localRef = useRef(null);
  const hasCoords = !!location?.coordinates;
  const hasAddress = !!location?.address;
  const hostRef = mapRef || localRef;

  // ensure the map host has a real height
  useEffect(() => {
    const el = hostRef?.current;
    if (!el) return;
    // nothing else: DoctorProfile controls map init
  }, [hostRef]);

  return (
    <div style={{ ...styles.section, paddingTop: 10 }}>
      <div style={{ ...styles.sectionHeader, gap: 8 }}>
        <MapPin style={{ width: 18, height: 18, color: "#10b981" }} />
        <h2 style={{ ...styles.sectionTitle, margin: 0, fontSize: 16 }}>Practice Location</h2>
      </div>

      <div style={{ ...styles.sectionContent, paddingTop: 8 }}>
        {/* Address / meta */}
        <div style={{ ...styles.locationInfo, gap: 6 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <MapPin style={{ width: 16, height: 16, color: "#3b82f6" }} />
            <span style={styles.locationText}>
              <strong>{doctorName}&apos;s Practice</strong>
            </span>
          </div>

          {hasAddress && (
            <div style={{ ...styles.locationText, wordBreak: "break-word" }}>
              {location.address}
            </div>
          )}

          
          {hasCoords && directionsUrl && (
            <a
              href={directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.directionsButton}
              className="directions-button"
            >
              <Navigation style={{ width: 14, height: 14 }} />
              Get Directions
            </a>
          )}
        </div>

        {/* Map area OR address-only fallback */}
        
        
      </div>
    </div>
  );
};

export default PracticeLocation;
